//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['property'],
    data: function data() {
        return {
            loading: true,
            headers: ['Building / Spaces Name', 'Total Units', 'Leased Units', 'Structure Type'],
            fields: ['name', 'units_count', 'leased_units_count', 'structure_type_name'],
            buildings: []
        };
    },

    methods: {
        refresh: function refresh() {
            var $el = this;
            if ($el.property) {
                this.loading = true;
                axios.get('/prototype/properties/buildings').then(function (response) {
                    if (response.data) {
                        $el.buildings = response.data;
                        $el.loading = false;
                    }
                });
            }
        },
        removeBuilding: function removeBuilding(buildingID) {
            var removeIndex = this.buildings.map(function (building) {
                return building.id;
            }).indexOf(buildingID);

            this.buildings.splice(removeIndex, 1);

            Event.$emit('unit-added');
        }
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;

        //this.refresh();

        Event.$on('show-property-tab-buildings', function () {
            return _this.refresh();
        });

        Event.$on('buildings-updated', function () {
            $el.refresh();
        });

        Event.$on('update-building', function (item, idx) {
            Event.$emit('edit-building', item);
        });

        Event.$on('view-buliding', function (item, idx) {
            Event.$emit('view-building', item);
        });

        Event.$on('remove-building', function (item, idx) {
            Event.$emit('confirm-delete', item, '/prototype/buildings/delete', 'building-deleted');
        });

        Event.$on('building-deleted', function (item, idx) {
            _this.removeBuilding(item.id);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/building/BuildingList.vue
// module id = NwQb
// module chunks = 0 1